import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ar from "date-fns/locale/ar";
import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
const DateRangeFilterRTL = ({ onDateChange, startDateInit, endDateInit }) => {
    const { t, i18n } = useTranslation();
    const [startDate, setStartDate] = useState(startDateInit ? startDateInit : null);
  const [endDate, setEndDate] = useState(endDateInit ? endDateInit : null);
  registerLocale("ar", ar); 
  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);

    // Pass the date range to the parent component
    if (onDateChange) {
      onDateChange({ startDate: start, endDate: end });
    }
  };
  return (
    <div   className="flex  flex-row items-center gap-4 p-4 ">
      {/* Start Date Picker */}
      <div className="flex flex-col">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          dateFormat={'dd-MMMM-YYYY'}
          endDate={endDate}
                locale={i18n.language === 'ar' ? 'ar' : 'en'}
          placeholderText={t('SelectStartDate')}
          className="border rounded-md p-2 text-black focus:outline-none focus:ring-2 focus:ring-indigo-500 text-start"
          popperPlacement="bottom-end" // RTL-friendly popover
        />
      </div>

      {/* End Date Picker */}
      <div className="flex flex-col">
        <DatePicker
          selected={endDate}
          locale={i18n.language === 'ar' ? 'ar' : 'en'}
          onChange={(date) => {
            setEndDate(date) 
            handleDateChange(startDate, date);
            }}
          selectsEnd
          startDate={startDate}
       dateFormat={'dd-MMMM-YYYY'}
          endDate={endDate}
          minDate={startDate}
          maxDate={new Date()}
          placeholderText={t('SelectEndDate')}
          className="border rounded-md p-2 text-black focus:outline-none focus:ring-2 focus:ring-indigo-500 text-start"
          popperPlacement="bottom-end" // RTL-friendly popover
        />
      </div> 
  {/* Filter Button */}
  <button
        onClick={() => handleDateChange(startDate, endDate)}
        className="px-4 py-2   text-white rounded-lg bg-[#B68A35] hover:bg-[#7b5e22]"
      > 
                     <FontAwesomeIcon icon={faSearch} color='#fff' />  
      </button>
    </div>
  );
};

export default DateRangeFilterRTL;
